export const formatBytes = (b) => {
  if (!b && b !== 0) return "—";
  if (b < 1024) return `${b} B`;
  if (b < 1024 ** 2) return `${(b / 1024).toFixed(1)} KB`;
  return `${(b / 1024 ** 2).toFixed(1)} MB`;
};

export const releasedAt = (r) => (r?.release_date ? `${r.release_date}T12:00:00` : r?.created_at);

export const formatDate = (iso, locale = "en-IN") =>
  iso ? new Date(iso).toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" }) : "—";

export const formatNumber = (n) => new Intl.NumberFormat("en-IN").format(n || 0);

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};
